import "./style.css";

function onClickButton() {
  window.open("https://e-waktusolat.my", "_self");
}

const NotFound = () => {
  return (
    <div className="not-found-root">
      <div className="not-found-content">
        <span className="not-found-text">404 Not Found</span>
        <span className="not-found-text-main">Oops! Page Not Found</span>
        <span className="not-found-text-desc">
          The page you are looking for doesn't exist. Click <br />
          button below to go to the homepage.
        </span>
        <button className="not-found-button-back" onClick={onClickButton}>
          Back to Homepage
        </button>
      </div>
    </div>
  );
};

export default NotFound;
